import {$qs} from '../../@shared/ts/dom';

function hidePeachPayPaymentMethods() {
	const paymentMethodList = $qs<HTMLUListElement>('ul.woocommerce-PaymentMethods.payment_methods.methods');

	if (!paymentMethodList) {
		return;
	}

	paymentMethodList.querySelectorAll('li').forEach($el => {
		if ($el.className.includes('peachpay') && !$el.className.includes('payment_method_peachpay_stripe_card')) {
			$el.remove();
		}
	});
}

document.addEventListener('DOMContentLoaded', () => {
	hidePeachPayPaymentMethods();
});
